





















































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import {
  IPaymentRequisition,
  User,
  IUser,
  PaymentRequisitionStatusEnum,
  PaymentRequisitionStatus
} from '@/models';

import { colors, classToHex } from '@/utils/colorUtils';
import { ErrorManager } from '@/models/error';
import { ExtractVue } from '@/utils/mixins';

import auth from '@/mixins/auth';

import PaymentRequisitionDetailFormDialog from '@/components/payment-requisition/PaymentRequisitionDetailFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import PaymentRequisitionAPSpecialistPicker from './PaymentRequisitionAPSpecialistPicker.vue';

export default auth.extend({
  name: 'PaymentRequisitionStateCard',

  components: {
    PaymentRequisitionDetailFormDialog,
    ConfirmationDialog,
    ErrorAlert,
    PaymentRequisitionAPSpecialistPicker
  },

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    }
  },

  data: () => ({
    loading: false,
    errorMessage: '',
    errorMessageDetail: '',
    PaymentRequisitionStatusEnum,

    submitPaymentRequititionApprover: null as null | IUser,
    submitPaymentRequititionDialog: false,

    approvePaymentRequisitionApprover: null as null | IUser,
    approvePaymentRequisitionDialog: false,

    assignPaymentRequititionAPSpecialist: null as null | IUser,
    assignAPSpecialistPaymentRequititionDialog: false,

    purchaseRequititionDialog: false,
    purchaseOrder: '',

    cancelRequsititionDialog: false,
    closeRequsititionDialog: false,

    // comment sections
    actionToState: -1,
    commentsRequsititionDialog: false,
    resolve: (null as unknown) as (
      value: boolean | PromiseLike<boolean>
    ) => void,
    paymentRequisitionComment: '',
    actionLabel: ''
  }),

  computed: {
    ...mapGetters({
      approvers: 'paymentRequisition/getPaymentRequisitionApprovers'
    }),

    authProvider(): any {
      return this.$altoleapAccounts.authProvider;
    },

    currentUser(): User {
      return this.authProvider.getCurrentUser;
    },

    commentMandatory(): boolean {
      return (
        (this.actionToState == PaymentRequisitionStatusEnum.Cancelled ||
          this.actionToState == PaymentRequisitionStatusEnum.Rejected) &&
        !(
          this.paymentRequisition.status!.value ==
            PaymentRequisitionStatusEnum.Submitted ||
          this.paymentRequisition.status!.value! ==
            PaymentRequisitionStatusEnum.Draft
        )
      );
    },

    mandatoryCommentFieldIsEmpty(): boolean {
      return (
        this.commentMandatory && this.paymentRequisitionComment.length == 0
      );
    },

    canApprove(): boolean {
      if (
        this.paymentRequisition.approvers &&
        this.paymentRequisition.approvers.length
      ) {
        const approver = this.paymentRequisition.approvers.find(
          requisitionApprover => {
            return (
              this.currentUser.id === (requisitionApprover.approver as IUser).id
            );
          }
        );
        //return true if approve is identified
        if (approver) {
          return true;
        }
      }
      return false;
    },

    canPay(): boolean {
      if (this.paymentRequisition.ap_specialist) {
        return (
          this.currentUser.id ===
          (this.paymentRequisition.ap_specialist as IUser).id
        );
      }
      return false;
    },

    isPaymentRequisitionOwner(): boolean {
      return (
        this.currentUser.id === (this.paymentRequisition.owner as IUser).id
      );
    },

    getStatusIcon(): string {
      return this.paymentRequisition.status!.getIcon();
    },

    getStatusColor(): string {
      return this.paymentRequisition.status!.getColor();
    },

    getStatusHexColor(): string {
      return classToHex(
        this.paymentRequisition.status!.getColor(),
        colors,
        this.$vuetify.theme.currentTheme
      );
    },

    paymentRequisitionApprovalStates() {
      return [PaymentRequisitionStatusEnum.Approval2Pending];
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  mounted() {
    this.loadNextPaymentRequisitionApprovers();
  },

  methods: {
    ...mapActions({
      updatePaymentRequisitionState:
        'paymentRequisition/updatePaymentRequisitionState',
      fetchPaymentRequisitionApprovers:
        'paymentRequisition/fetchPaymentRequisitionApprovers',
      fetchPaymentRequisitionActivities:
        'paymentRequisition/fetchPaymentRequisitionActivities'
    }),

    getStatusMessage(state: PaymentRequisitionStatusEnum): string {
      return PaymentRequisitionStatus.getStatusMessageFromState(state);
    },

    setActionLabel(state: PaymentRequisitionStatusEnum) {
      switch (state) {
        case PaymentRequisitionStatusEnum.Draft:
          this.actionLabel = '';
          break;

        case PaymentRequisitionStatusEnum.Submitted:
          this.actionLabel = 'Submit';
          break;

        case PaymentRequisitionStatusEnum.InReview:
        case PaymentRequisitionStatusEnum.Approval2Pending:
          this.actionLabel = 'Start Review';
          break;

        case PaymentRequisitionStatusEnum.Approved:
          this.actionLabel = 'Approve';
          break;

        case PaymentRequisitionStatusEnum.Rejected:
          this.actionLabel = 'Reject';
          break;

        case PaymentRequisitionStatusEnum.Cancelled:
          this.actionLabel = 'Cancel';
          break;

        case PaymentRequisitionStatusEnum.Paid:
          this.actionLabel = 'Close';
          break;

        default:
          this.actionLabel = 'Submit';
          break;
      }
    },

    updatePaymentRequisition(): void {
      const paymentRequisitionFormDialog = this.$refs
        .paymentRequisitionDetailFormDialog as ExtractVue<
        typeof PaymentRequisitionDetailFormDialog
      >;
      paymentRequisitionFormDialog.open(this.paymentRequisition, true);
    },

    agreeCommentsDialog() {
      this.commentsRequsititionDialog = false;
      return this.resolve(true);
    },

    cancelCommentsDialog() {
      this.commentsRequsititionDialog = false;
      return this.resolve(false);
    },

    /**
     * @summary Await this dialog to close before continuing into the next action.
     */
    openCommentsDialog(toState: PaymentRequisitionStatusEnum) {
      this.actionToState = toState;
      this.setActionLabel(toState);

      this.paymentRequisitionComment = '';
      this.commentsRequsititionDialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
      });
    },

    /**
     * @see api paymentRequisition/models/start_review
     * can be called only from states:
     * - Draft
     *
     * can go to states
     * - Submitted
     *
     * if approver not assigned then call @see undoSubmit
     */
    submit(assignee: number): void {
      this.clearAllErrors();

      this.loading = true;

      this.updatePaymentRequisitionState({
        paymentRequisitionId: this.paymentRequisition.id,
        state: PaymentRequisitionStatusEnum.Submitted,
        assignee: assignee
      })
        .then(() => {
          this.submitPaymentRequititionDialog = false;
          this.submitPaymentRequititionApprover = null;
          this.$emit('submitted');
          this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api paymentRequisition/models/start_review
     * can be called only from states:
     * - Submitted
     *
     * can go to states
     * - Draft
     */
    undoSubmit() {
      this.clearAllErrors();
      this.loading = true;
      this.updatePaymentRequisitionState({
        paymentRequisitionId: this.paymentRequisition.id,
        state: PaymentRequisitionStatusEnum.Draft
      })
        .then(() => {
          this.$emit('undo-submit');
          this.loadNextPaymentRequisitionApprovers();
          this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api paymentRequisition/models/start_review
     * can be called only from states:
     * - Submitted
     *
     * can go to states
     * - InReview
     */
    startReview(): void {
      this.clearAllErrors();
      this.loading = true;
      this.updatePaymentRequisitionState({
        paymentRequisitionId: this.paymentRequisition.id,
        state: PaymentRequisitionStatusEnum.InReview
      })
        .then(() => {
          this.$emit('start-review');
          this.loadNextPaymentRequisitionApprovers();
          this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * @see api paymentRequisition/models/reject
     * @param {number} assignee
     * can be called only from states:
     * - Any State
     *
     * can go to states
     * - Rejected
     */
    async reject(assignee: number): Promise<void> {
      if (
        await this.openCommentsDialog(PaymentRequisitionStatusEnum.Rejected)
      ) {
        this.clearAllErrors();
        this.loading = true;
        this.updatePaymentRequisitionState({
          paymentRequisitionId: this.paymentRequisition.id,
          state: PaymentRequisitionStatusEnum.Rejected,
          assignee: assignee, //only current user can reject a requistion,
          comment: this.paymentRequisitionComment
        })

          .then(() => {
            this.$emit('reject');
            this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api paymentRequisition/models/approve
     * @param {number} assignee
     * can be called only from states:
     * - InReview
     *
     * can go to states
     * - Approved
     */
    async approve(assignee: number): Promise<void> {
      if (
        await this.openCommentsDialog(PaymentRequisitionStatusEnum.Approved)
      ) {
        this.clearAllErrors();
        this.loading = true;

        this.updatePaymentRequisitionState({
          paymentRequisitionId: this.paymentRequisition.id,
          state: PaymentRequisitionStatusEnum.Approved,
          assignee: assignee,
          comment: this.paymentRequisitionComment
        })
          .then(() => {
            this.approvePaymentRequisitionApprover = null;
            this.approvePaymentRequisitionDialog = false;
            this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.approvePaymentRequisitionDialog = false;
      }
    },

    /**
     * @see api requisition/models/assign_buyer
     * can be called only from states:
     * - Approved
     *
     * can go to states
     * - BuyerAssigned
     */
    async assignAPSpecialist(assignee: number): Promise<void> {
      if (
        await this.openCommentsDialog(
          PaymentRequisitionStatusEnum.APSpecialistAssigned
        )
      ) {
        this.clearAllErrors();

        this.loading = true;

        this.updatePaymentRequisitionState({
          paymentRequisitionId: this.paymentRequisition.id,
          state: PaymentRequisitionStatusEnum.APSpecialistAssigned,
          assignee: assignee,
          comment: this.paymentRequisitionComment
        })
          .then(() => {
            this.assignAPSpecialistPaymentRequititionDialog = false;
            this.assignPaymentRequititionAPSpecialist = null;
            this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api paymentRequisition/models/paid
     * @param {number} assignee
     * can be called only from states:
     * - InReview
     *
     * can go to states
     * - Approved
     */
    async paid(assignee: number): Promise<void> {
      this.clearAllErrors();

      if (await this.openCommentsDialog(PaymentRequisitionStatusEnum.Paid)) {
        this.loading = true;

        this.updatePaymentRequisitionState({
          paymentRequisitionId: this.paymentRequisition.id,
          state: PaymentRequisitionStatusEnum.Paid,
          assignee: assignee,
          comment: this.paymentRequisitionComment
        })
          .then(() => {
            this.$emit('paid');
            this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api paymentRequisition/models/cancel
     * can be called only from states:
     * - Any state
     *
     * can go to states
     * - Cancel
     */
    async cancel(): Promise<void> {
      if (
        await this.openCommentsDialog(PaymentRequisitionStatusEnum.Cancelled)
      ) {
        this.clearAllErrors();
        this.loading = true;
        this.updatePaymentRequisitionState({
          paymentRequisitionId: this.paymentRequisition.id,
          state: PaymentRequisitionStatusEnum.Cancelled,
          comment: this.paymentRequisitionComment
        })
          .then(() => {
            this.$emit('cancel');
            this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    /**
     * @see api paymentRequisition/models/close
     * can be called only from states:
     * - Rejected
     * - Cancelled
     * - Purchase Complete
     *
     * can go to states
     * - Close
     */
    async close(): Promise<void> {
      if (await this.openCommentsDialog(PaymentRequisitionStatusEnum.Paid)) {
        this.clearAllErrors();
        this.loading = true;
        this.updatePaymentRequisitionState({
          paymentRequisitionId: this.paymentRequisition.id,
          state: PaymentRequisitionStatusEnum.Paid
        })
          .then(() => {
            this.closeRequsititionDialog = false;
            this.$emit('close');
            this.fetchPaymentRequisitionActivities(this.paymentRequisition.id);
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.errorMessageDetail = '';
    },

    /**
     * Creates a csv file from server blob data
     */
    createHeaderFile({ data, id }: { data: Blob; id: number }) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      const linkName = `${id}-po_header-${moment(new Date()).format(
        'YYYY-MM-DD-HH-mm-ss'
      )}.csv`;
      link.href = url;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    /**
     * Creates a csv file from server blob data
     */
    createLineFile({ data, id }: { data: Blob; id: number }) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      const linkName = `${id}-po_lines-${moment(new Date()).format(
        'YYYY-MM-DD-HH-mm-ss'
      )}.csv`;
      link.href = url;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    loadNextPaymentRequisitionApprovers() {
      this.loading = true;
      return this.fetchPaymentRequisitionApprovers(this.paymentRequisition.id)
        .catch(() => {
          this.errorMessage = 'Error getting approvers';
        })
        .finally(() => (this.loading = false));
    }
  }
});
